import styled from "styled-components";

export const DivX = styled.div`
  width: 100%;
  text-align: right;
`;